import { useEffect, useState } from "react";
import { breakpoints } from "@duro-app/tokens/tokens/breakpoints.css";

/**
 * True when the viewport is at/under the mobile breakpoint. Extracted
 * from FormatToolbar so the format bar and the settings drawer share one
 * source of truth for the 768px desktop/mobile split.
 */
export function useIsMobile(query = `(max-width: ${breakpoints.md})`): boolean {
  const [m, setM] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setM(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return m;
}
